import { render, staticRenderFns } from "./CardBase.vue?vue&type=template&id=b09848e8&scoped=true"
import script from "./CardBase.vue?vue&type=script&lang=js"
export * from "./CardBase.vue?vue&type=script&lang=js"
import style0 from "./CardBase.vue?vue&type=style&index=0&id=b09848e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09848e8",
  null
  
)

export default component.exports